import React, { useState, useEffect, useRef } from "react"
import { usePathname } from "next/navigation"
import FlyButton from "components/FlyButton"
// import PopupVQ from "components/PopupVQ"
import PopupButton from "components/PopupButton"
import useStore from "components/ui/Context"
import { apiChannel, apiPayment } from "api"

const EventButton = () => {
  const pathname = usePathname()
  const [openPopup, setOpenPopup] = useState(false)
  const [dataEventState, setDataEventState] = useState(null)
  const [dataPopup, setDataPopup] = useState(null)
  const { userInfo, togleModalLogin, setDataEvent, setDataSubscription } = useStore()
  const __paramDevice = useRef({
    page_num: 1,
    page_size: 30
  })
  // function onChangeModal() {
  //   togleModalLogin()
  // }
  const getMySubscription = async () => {
    try {
      const { data, success } = await apiPayment.getMySub(__paramDevice.current)
      if (success) {
        setDataSubscription(data)
      } else {
        console.error("Failed to fetch events")
      }
    } catch (error) {
      console.error("Error fetching events:", error)
    }
  }
  const getEvents = async () => {
    try {
      const { data, success } = await apiChannel.getEvents()
      if (success) {
        setDataEvent(data?.lucky_wheel)
        setDataEventState(data?.lucky_wheel)
        setDataPopup(data?.popup_ads)
      } else {
        console.error("Failed to fetch events")
      }
    } catch (error) {
      console.error("Error fetching events:", error)
    }
  }
  useEffect(() => {
    getEvents()
    if (userInfo && userInfo.id) {
      getMySubscription()
    }
  }, [userInfo])

  const hiddenPaths = [
    "/chinh-sach",
    "/chinh-sach-app",
    "/chinh-sach-bao-ve-du-lieu-ca-nhan",
    "/chinh-sach-bao-ve-thong-tin-khach-hang",
    "/dieu-khoan-app",
    "/dieu-khoan-giao-dich"
  ]

  if (hiddenPaths.includes(pathname)) return null

  return (
    <>
      <FlyButton dataEventState={dataEventState} openPopup={openPopup} setOpenPopup={setOpenPopup} />
      {/* <PopupVQ
        setIsRedirectEvent={setIsRedirectEvent}
        dataSubscriptionState={dataSubscriptionState}
        dataEventState={dataEventState}
        userInfo={userInfo}
        onChangeModal={onChangeModal}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      /> */}
      {dataPopup && <PopupButton dataPopup={dataPopup} />}
    </>
  )
}

export default EventButton
